import React, { useState } from 'react';
import { Row, Col, Button, Container, FormInput, FormSelect, Badge } from 'shards-react';
import PageTitle from '../../../components/PageTitle';
import Translator from '../../../services/Translator';
import DocumentService from '../../../services/DocumentService';
import {
  Table,
  THead,
  Th,
  Td,
  TableRow,
  TableHeader,
  TableWrapper,
  H3
} from '@increase/typed-components';

import { Can } from '../../../permissions/helper';
import CantAuthorize from '../../../components/common/CantAuthorize';

const SCRAPER_TYPE = 'scraper';
const PARSER_TYPE = 'parser';
const API_TYPE = 'api';

const DOCUMENT_IDS_PLACEHOLDER = 'Documento(s) ID separados por coma';
const PAYMENT_IDS_PLACEHOLDER = 'Liquidacion(es) ID separados por coma';

const REPARSE_TYPES = [
  {
    id: SCRAPER_TYPE,
    label: 'Scraper',
    serviceFunction: 'reparseScraper',
    placeholder: DOCUMENT_IDS_PLACEHOLDER,
    help: 'Cuando no se creó el parsing_job, o faltó crear alguno. También cuando quedaron en pending o enqueued y no corrieron.'
  },
  {
    id: PARSER_TYPE,
    label: 'Parser',
    serviceFunction: 'reparseParser',
    placeholder: DOCUMENT_IDS_PLACEHOLDER,
    help: 'Cuando el parseo falló, o se parseó con una versión anterior y hay que correrlo de nuevo con una más nueva, sin borrar los payments.'
  },
  {
    id: API_TYPE,
    label: 'Api',
    serviceFunction: 'reparseApi',
    placeholder: PAYMENT_IDS_PLACEHOLDER,
    help: 'Cuando hay que borrar los payments ya generados por ese documento y crearlos de nuevo. Por ejemplo, un problema de versión: se quieren regenerar solo como versión 1, sin dejar versiones nuevas conviviendo con las anteriores.'
  }
];

export function SupportReparse() {
  const [documents, setDocuments] = useState('');
  const [reparseType, setReparseType] = useState(SCRAPER_TYPE);
  const [result, setResult] = useState();
  const [resultType, setResultType] = useState(SCRAPER_TYPE);

  const handleDocumentsChange = (e) => {
    const value = e.target.value;
    // remove spaces
    const trimmed = value.replace(/\s/g, '');
    setDocuments(trimmed);
  };

  const handleTypeChange = (e) => {
    setReparseType(e.target.value);
  };

  const onReparse = () => {
    // clear results
    setResult(undefined);
    setResultType(reparseType);
    // convert to array & filter empty items
    const documentsArray = documents.split(',').filter((docId) => docId !== '');
    // call service
    reparseDocuments(documentsArray);
  };

  const reparseDocuments = async (documentsArray) => {
    const documentService = await DocumentService();
    const serviceFunction = REPARSE_TYPES.find((type) => type.id === reparseType).serviceFunction;
    documentService[serviceFunction](documentsArray).then((data) => setResult(data));
  };

  const resultHasData = result && Array.isArray(result) && result.length > 0;
  const selectedType = REPARSE_TYPES.find((type) => type.id === reparseType) || REPARSE_TYPES[0];
  const idColumnLabel = resultType === API_TYPE ? 'Liquidación' : 'Documento';

  return (
    <Container className="main-content-container px-4" fluid>
      <Row className="page-header py-4" noGutters>
        <PageTitle className="text-sm-left" sm="4" subtitle="" title="Reparser" />
      </Row>
      <Can action="sup:reparse" renderIfCant={<CantAuthorize />}>
        <Row>
          <Col lg="8" sm="12" xs="12">
            <FormInput
              id="documents"
              onChange={handleDocumentsChange}
              placeholder={selectedType.placeholder}
              type="text"
              value={documents}
            />
          </Col>
          <Col lg="2" sm="4" xs="12">
            <FormSelect
              className="form-control"
              id="reparseType"
              name="reparseType"
              onChange={handleTypeChange}
              value={reparseType}
            >
              {REPARSE_TYPES.map((type) => {
                return (
                  <option key={type.id} value={type.id}>
                    {type.label}
                  </option>
                );
              })}
            </FormSelect>
          </Col>
          <Col lg="2" sm="4" xs="12">
            <Button disabled={documents === ''} onClick={onReparse}>
              Reparsear
            </Button>
          </Col>
        </Row>
        <Row>
          <Col>
            <p className="text-muted mt-3 mb-0">{selectedType.help}</p>
          </Col>
        </Row>
      </Can>
      {result && (
        <Row>
          <Col>
            <TableWrapper className="MarginTop20">
              <TableHeader>
                <H3>Resultado {resultType.toUpperCase()}</H3>
              </TableHeader>
              <Table hasData={resultHasData} noDataMessage="No hay datos" zebra>
                <THead>
                  <tr>
                    <Th>{idColumnLabel}</Th>
                    <Th>Estado</Th>
                  </tr>
                </THead>
                <tbody>
                  {resultHasData &&
                    result.map((documents) => {
                      const statusIsNotFound = documents.status === 'not_found';
                      const statusDescription = Translator.reparseStatus(documents.status);
                      return (
                        <TableRow key={documents.id}>
                          <Td>{documents.id}</Td>
                          <Td>
                            <H3>
                              <Badge pill theme={statusIsNotFound ? 'danger' : 'success'}>
                                {statusDescription}
                              </Badge>
                            </H3>
                          </Td>
                        </TableRow>
                      );
                    })}
                </tbody>
              </Table>
            </TableWrapper>
          </Col>
        </Row>
      )}
    </Container>
  );
}
